import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { toast } from 'react-toastify';
import client from '../../utils/apolloClient';

const generateInvoiceMutation = gql`
  mutation generateInvoice($input: GenerateInvoiceInput) {
    generate_invoice(input: $input) {
      invoice_url
      error {
        code
        description
        object {
          id
          name
          type
        }
      }
    }
  }
`;

const useGenerateInvoice = () => {
  const [generateInvoice, { loading }] = useMutation(generateInvoiceMutation, {
    client: client.clientPrivate,
  });

  const generateInvoiceHandler = async order_reference => {
    try {
      const res = await generateInvoice({
        variables: { input: { order_reference } },
      });

      const payload = res?.data?.generate_invoice;

      if (payload?.error) {
        toast.error(payload.error.description || 'Something went wrong');
        return;
      }

      const url = payload?.invoice_url;

      if (url) {
        const response = await fetch(url);
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `invoice-${order_reference}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        toast.success('Invoice downloaded');
      } else {
        toast.error('Invoice not available');
      }
    } catch (err) {
      toast.error(err.message || 'Failed to generate invoice');
    }
  };

  return { generateInvoice: generateInvoiceHandler, loading };
};

export default useGenerateInvoice;
